import { CommercialDocumentViewModel, SortableTreeNodeCommercial, CommercialDocumentLineItemViewModel } from "./commercialDocumentsInterfaces";
import { Helper } from "../core/util/helper";

export class TreeHelper {

    public static sync(vm: CommercialDocumentViewModel): SortableTreeNodeCommercial {
        var root = this.createSortableTreeNodeCommercial(vm, null);
        root.Title = vm.Title;
        root.Price = vm.Net_Foreign;
        root.Currency = vm.Currency_Foreign_Symbol;

        vm.LineItems.map(r => {
            var child = this.createSortableTreeNodeCommercial(vm, r);
            child.parent = root;
            root.children.push(child);
            this.syncLineItem(vm, r, child)
        });

        return root;
    }

    public static getTreeNode(root: SortableTreeNodeCommercial, id: string): SortableTreeNodeCommercial {
        if (root.Id == id)
            return root;

        for (var node of root.children) {
            if (node.Id == id)
                return node;
            let resultChildren = this.getTreeNode(node, id);
            if (resultChildren != null)
                return resultChildren;
        }
        return null;
    }

    public static getLineItemFromTreeNode(node: SortableTreeNodeCommercial, vm: CommercialDocumentViewModel): CommercialDocumentLineItemViewModel {
        if (node.Id == null)
            return null;

        if (node.Path == null) {
            return vm.LineItems[Helper.findIndex(vm.LineItems, "Id", node.Id)];
        }
        else {
            let pathElements = node.Path.split(".");
            let currNode = vm.LineItems[Helper.findIndex(vm.LineItems, "Id", pathElements[0])];
            for (let i = 1; i < pathElements.length; i++) {
                currNode = currNode.LineItems[Helper.findIndex(currNode.LineItems, "Id", pathElements[i])];
            }

            return currNode.LineItems[Helper.findIndex(currNode.LineItems, "Id", node.Id)];
        }

        return null;
    }

    public static getTreeNodeFromLineItem(root: SortableTreeNodeCommercial, lineItem: CommercialDocumentLineItemViewModel): SortableTreeNodeCommercial {
        if (lineItem.Path == null) {
            return root.children[Helper.findIndex(root.children, "Id", lineItem.Id)];
        }
        else {
            let pathElements = lineItem.Path.split(".");
            let currNode = root.children[Helper.findIndex(root.children, "Id", pathElements[0])];
            for (let i = 1; i < pathElements.length; i++) {
                currNode = currNode.children[Helper.findIndex(currNode.children, "Id", pathElements[i])];
            }

            return currNode.children[Helper.findIndex(currNode.children, "Id", lineItem.Id)];
        }

        return null;
    }

    private static syncLineItem(vmRoot: CommercialDocumentViewModel, vm: CommercialDocumentLineItemViewModel, root: SortableTreeNodeCommercial) {
        vm.LineItems.map(r => {
            var child = this.createSortableTreeNodeCommercial(vmRoot, r);
            child.parent = root;
            root.children.push(child);
            this.syncLineItem(vmRoot, r, child)
        });
    }

    private static createSortableTreeNodeCommercial(vmRoot: CommercialDocumentViewModel, vm: CommercialDocumentLineItemViewModel): SortableTreeNodeCommercial {
        return {
            Id: vm == null ? null : vm.Id,
            Path: vm == null ? null : vm.Path,
            parent: null,
            children: [],
            canHaveChildren: vm == null || vm.Deliverable_Type == null,
            Title: vm != null ? vm.Title : null,
            Deliverable_Type: vm != null ? vm.Deliverable_Type : null,
            Invoicing_Type: vm != null ? vm.Invoicing_Type : null,
            Price: vm != null ? vm.Sum_Price_Foreign_Modified : null,
            Currency: vm != null ? vmRoot.Currency_Foreign_Symbol : null,
            Quantity: vm != null ? vm.Quantity : null,
        };
    }
}